module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_vm._v("AUTHOR’S NOTE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The footers in the first section trace a journey across the body of a cow. The footers in the second section are the main buildings in the family farm providing the physical definition of home. The footers in the final section are the many different spellings of the family name. As many of the descendants in the past were illiterate farm workers this has led to the variety seen today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A number of poems in the first part of the book have been inspired by the work of the Glasgow Boys in the late nineteenth century. Early in their careers, some of the artists focussed on working ‘en plein air’ within rural communities trying to capture a more naturalistic response to those who worked there. The following works have been used as starting points to poems in the collection:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("Landscape with Cattle")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b"
  }, [_vm._v("Joseph Crawhall")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("A Hind’s Daughter")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b"
  }, [_vm._v("James Guthrie")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("Boy with a Straw")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b"
  }, [_vm._v("James Guthrie")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("Schoolmates")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b"
  }, [_vm._v("James Guthrie")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("The Milkmaid")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b"
  }, [_vm._v("George Henry")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("Sheep Shearing")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b"
  }, [_vm._v("James Guthrie")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("The Hedgecutter")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b"
  }, [_vm._v("George Henry")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("Gypsy Fires are Burning for"), _c('br'), _vm._v("Daylight’s Past and Gone")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b1"
  }, [_vm._v("James Guthrie")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab-a"
  }, [_c('em', [_vm._v("The Gamekeeper’s Daughter")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab-b"
  }, [_vm._v("E.A. Walton")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("‘Playing the Milkmaid in the Hameau de la Reine’: Marie Antionette used to amuse herself and her friends by portraying a milkmaid in her own rustic landscape created by architect Richard Mique.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("‘Four millimetres’ describes the regular TB testing of cattle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("‘My Wife’s Whistle’: Wellees is the name of my brother-in-law’s farm.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bd60a68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 75
// module chunks = 0